import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
// styles
import { OnboardingStyles } from "./onboarding.styles";
// assets
import { BenefitLogoIcon } from "../../../../assets/Icons";
// components
import { Button } from "../../../../components";
// services
import * as api from "../../../../services/api/employee/employeeBenefits.services";
// actions
import * as actionCreators from "../../../../actions/app.actions";
import { useTranslation } from "react-i18next";

const EmployeeOnboarding = ({ finishEmployeeOnboarding }) => {
  const { t } = useTranslation();
  const handleFinishOnboarding = async () => {
    const response = await api.finishOnboarding();
    if (response.hasError) {
      return toast.error(
        response.errorMessage
          ? t(response.errorMessage)
          : t("failed_to_onboard")
      );
    }
    finishEmployeeOnboarding();
  };

  return (
    <OnboardingStyles>
      <div className="circleLogoContainer">
        <BenefitLogoIcon />
      </div>
      <h3 className="title">{t("benefiti_welcome")}</h3>
      <p className="text">{t("benefiti_greetings")}</p>
      <p className="text">
        {t("benefiti_greetings_message")}
        <a
          href="mailto:info@benefiti.rs"
          target="_blank"
          rel="noopener noreferrer"
          style={{ cursor: "pointer" }}
        >
          info@benefiti.rs
        </a>
        .
      </p>
      <p className="text">{t("benefit_team")}</p>
      <Button
        width="130px"
        onClick={() => handleFinishOnboarding()}
        margin="20px 0 0 0"
      >
        Ok
      </Button>
    </OnboardingStyles>
  );
};

EmployeeOnboarding.propTypes = {
  finishOnboarding: PropTypes.func
};

const mapDispatchToProps = dispatch => {
  return {
    finishEmployeeOnboarding: () =>
      dispatch(actionCreators.finishEmployeeOnboarding())
  };
};

export default connect(null, mapDispatchToProps)(EmployeeOnboarding);
